import AboutUsCards from './about-us-cards';

export default AboutUsCards;
